import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const ROWS = [
  ["M (38)", 35, 37, 38, 36, 40],
  ["L (40)", 35, 39, 40, 38, 42],
  ["XL (42)", 35, 39, 42, 40, 44],
  ["XXL (44)", 35, 39, 44, 42, 46],
  ["3XL (46)", 35, 39, 46, 44, 48],
  ["4XL (48)", 35, 39, 48, 46, 50],
  ["5XL (50)", 36, 39, 50, 48, 52],
  ["6XL (52)", 36, 39, 52, 50, 54],
];

export default function SizeGuideModal({ children }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-2xl" data-testid="size-guide-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl">Size Guide</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-mutedc">All measurements in inches (garment flat measurements). Our size numbers correspond to to-fit bust (M = 38). Between sizes? Size up for a drapier fall.</p>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[560px] border-collapse text-sm" data-testid="size-guide-table">
            <thead>
              <tr className="border-b border-ink/20 font-mono text-[10px] uppercase tracking-widest text-mutedc">
                <th className="py-3 text-left">Size</th>
                <th className="py-3 text-right">Top Length</th>
                <th className="py-3 text-right">Bottom Length</th>
                <th className="py-3 text-right">Bust</th>
                <th className="py-3 text-right">Waist</th>
                <th className="py-3 text-right">Hips</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r[0]} className="border-b border-linec">
                  <td className="py-2.5 font-semibold">{r[0]}</td>
                  <td className="py-2.5 text-right font-mono text-xs">{r[1]}"</td>
                  <td className="py-2.5 text-right font-mono text-xs">{r[2]}"</td>
                  <td className="py-2.5 text-right font-mono text-xs">{r[3]}"</td>
                  <td className="py-2.5 text-right font-mono text-xs">{r[4]}"</td>
                  <td className="py-2.5 text-right font-mono text-xs">{r[5]}"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="font-mono text-[10px] uppercase tracking-widest text-mutedc">Pls note: a variation of +/- 1 inch may occur due to fabric viscosity and is not considered as defective or wrong size.</p>
        <p className="font-mono text-[10px] uppercase tracking-widest text-mutedc">Questions on fit? WhatsApp us — we reply within hours.</p>
      </DialogContent>
    </Dialog>
  );
}
